import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ["sectionList", "sectionItem", "sectionPanel"]
  static values = {
    listingId: String,
    reorderUrl: String
  }

  connect() {
    this.initSortable()
  }

  initSortable() {
    if (!this.hasSectionListTarget) return

    this.sortable = Sortable.create(this.sectionListTarget, {
      animation: 150,
      handle: "[data-guidebook-editor-target='dragHandle']",
      onEnd: (event) => this.handleReorder(event)
    })
  }

  selectSection(event) {
    const item = event.currentTarget
    const sectionId = item.dataset.sectionId

    // Update sidebar active state
    this.sectionItemTargets.forEach(el => {
      el.classList.remove("bg-emerald-50")
    })
    item.classList.add("bg-emerald-50")

    // Show corresponding panel
    this.sectionPanelTargets.forEach(panel => {
      if (panel.dataset.sectionId === sectionId) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  async handleReorder(event) {
    const items = this.sectionListTarget.querySelectorAll("[data-section-id]")

    const promises = Array.from(items).map((item, index) => {
      const sectionId = item.dataset.sectionId
      const url = `${this.reorderUrlValue}/${sectionId}/reorder`

      return patch(url, {
        body: JSON.stringify({ position: index }),
        contentType: "application/json"
      })
    })

    await Promise.all(promises)
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }
}
